export default __webpack_public_path__ + "static/fargebruk-eksempel2-9e85a65c12ced7017b9724deb4eeec24.png";